import React from "react";
import Carousel from "components/common/Carousel";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";
import Label from "components/common/Label";

const Block = ({ block, carouselItemRender, carouselOptions }) => {
  const { language, dir } = useAppSelector(getSettings);

  return (
    <>
      <Label
        lang={language}
        dir={dir}
      >
        {(block?.category && block?.category.title[language]) ||
          t('youMayBeInteresed')}
      </Label>
      {Array.isArray(block.lifeChoices) ? (
        <Carousel
          renderItem={carouselItemRender}
          items={block.lifeChoices}
          options={carouselOptions}
          navigationUI={
            <div
              className={`absolute top-0 w-16 h-full z-10 to-transparent via-50% via-[#ffffffb8] from-white ${
                dir === "rtl"
                  ? "left-0 bg-gradient-to-r"
                  : "right-0 bg-gradient-to-l"
              }`}
            ></div>
          }
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Block;
